(function () {
  var STEP_SELECTORS = [
    '.la-choose-prescription-wrapper.la-render-options',
    '.la-choose-prescription-wrapper.la-render-lenses:not(.x-pro)'
  ];
  var LENS_GROUP_STEP_SELECTOR = '.la-choose-prescription-wrapper.la-render-lenses.x-pro';
  var SCOPE_CLASS = 'ciw-la-lens-color-step';
  var PICKED_CLASS = 'ciw-la-lens-card--picked';
  var BODY_ACTIVE_CLASS = 'ciw-la-lens-color-continue-active';
  var TIER_HIDDEN_CLASS = 'ciw-la-combined-tier-hidden';
  var COLOR_HIDDEN_CLASS = 'ciw-la-combined-color-hidden';
  var LIST_PLAIN_CLASS = 'ciw-la-combined-list-plain';
  var pendingWrapper = null;
  var confirming = false;
  var boundScope = null;
  var combinedColorConfirmed = false;
  var combinedPhaseBWatch = null;

  window.ciwLaLensColorContinue = {
    isActive: function () {
      return document.body.classList.contains(BODY_ACTIVE_CLASS);
    },
    hasSelection: function () {
      return !!pendingWrapper;
    },
    isContinueEnabled: function () {
      return canContinue();
    },
    isColorScope: function (scope) {
      return isColorOptionScope(scope);
    },
    isCombinedColorPhase: function () {
      return isCombinedColorPhaseActive();
    },
    isCombinedColorConfirmed: function () {
      return combinedColorConfirmed;
    },
    isNonPrescriptionCombinedScope: function (scope) {
      return isNonPrescriptionCombinedScope(scope);
    },
    markCombinedColorConfirmedFromDrawer: function () {
      return markCombinedColorConfirmedFromDrawer();
    }
  };

  function normalizeLabel(text) {
    return String(text || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isLikelyThicknessTierName(name) {
    return /^(basic|standard|polycarbonate|premium|supreme\+?)$/i.test(
      normalizeLabel(name).split(' - ')[0]
    );
  }

  function isLikelyTransitionTypeName(name) {
    var label = normalizeLabel(name).split(' - ')[0];
    if (!label || isLikelyThicknessTierName(label)) return false;
    if (/^transitions?\s+(?:gen\s*s|xtr\s*active|xtractive)/i.test(label)) return true;
    if (/^photo\s*c?r?omic$/i.test(label)) return true;
    if (/^transitions?\s+gen\s*s$/i.test(label)) return true;
    if (/^transitions?\s+xtr\s*active$/i.test(label)) return true;
    return false;
  }

  var COLOR_STEP_HEADING_PATTERNS = {
    photochromic:
      /select\s+choose\s+color\s+for\s+photo\s*c?r?omic|choose\s+color\s+for\s+photo\s*c?r?omic/i,
    'gen-s':
      /select\s+transition\s+color\s+for\s+transitions\s+gen\s*s/i,
    'xtr-active':
      /select\s+transition\s+x\s*tract?ive\s+color\s+for\s+transitions\s+xtr\s*active/i
  };

  function matchesKnownColorStepHeading(title) {
    var label = normalizeLabel(title);
    if (!label) return false;
    return (
      COLOR_STEP_HEADING_PATTERNS.photochromic.test(label) ||
      COLOR_STEP_HEADING_PATTERNS['gen-s'].test(label) ||
      COLOR_STEP_HEADING_PATTERNS['xtr-active'].test(label)
    );
  }

  function isLensColorOptionTitle(title) {
    var label = normalizeLabel(title);
    if (matchesKnownColorStepHeading(label)) return true;
    if (/select\s+choose\s+color/i.test(label)) return true;
    if (/select\s+transition\s+color/i.test(label)) return true;
    if (/select\s+transition\s+x\s*tract?ive\s+color/i.test(label)) return true;
    if (
      /(?:photo\s*c?r?omic|transitions?\s+gen\s*s|transitions?\s+xtr\s*active|xtractive).+\bcolor\b|\bcolor\b.+(?:photo\s*c?r?omic|transitions?\s+gen\s*s|xtr\s*active|xtractive)/i.test(
        label
      )
    ) {
      return true;
    }
    return /select\s*color|select\s*transition|transition\s*color|lens\s*color|photochromic\s*color|xtr\s*active\s*color|xtractive\s*color|^color$/i.test(
      label
    );
  }

  function isExplicitColorStepScope(scope) {
    if (!scope) return false;
    var title = getScopeTitle(scope);
    return matchesKnownColorStepHeading(title) || isLensColorOptionTitle(title);
  }

  function classifyTransitionType(label) {
    label = normalizeLabel(label);
    if (!label) return null;
    if (/photo\s*c?r?omic/i.test(label) && !/gen\s*s|xtr\s*active|xtractive/i.test(label)) {
      return 'photochromic';
    }
    if (/xtr\s*active|xtractive/i.test(label)) return 'xtr-active';
    if (/gen\s*s/i.test(label)) return 'gen-s';
    return null;
  }

  function getSelectedTransitionTypeFromDom() {
    var lensesStep = document.querySelector(
      '.la-choose-prescription-wrapper.la-render-lenses:not(.x-pro)'
    );
    if (!lensesStep) return '';

    var checked = lensesStep.querySelector('input[type="radio"].la-tap-select:checked');
    if (checked) {
      var checkedBtn = checked.closest('.la-label-btn');
      var checkedTitleNode = checkedBtn && checkedBtn.querySelector('.la-label-title');
      var checkedLabel = checkedTitleNode ? checkedTitleNode.textContent : checked.value || '';
      checkedLabel = normalizeLabel(checkedLabel);
      if (classifyTransitionType(checkedLabel)) return checkedLabel;
    }

    var pickedTitleNode = lensesStep.querySelector('.ciw-la-lens-card--picked .la-label-title');
    if (pickedTitleNode) {
      var pickedLabel = normalizeLabel(pickedTitleNode.textContent);
      if (classifyTransitionType(pickedLabel)) return pickedLabel;
    }

    return '';
  }

  function getSelectedTransitionTypeName(la) {
    la = la || window.LensAdvizor;

    if (la) {
      var chooseLenses = getLensAdvizorCustomOptionValue(la, /choose\s*your\s*lenses/i);
      if (chooseLenses && classifyTransitionType(chooseLenses)) {
        return chooseLenses;
      }

      if (la.response && la.response.lens && la.response.lens.name) {
        var lensName = normalizeLabel(la.response.lens.name);
        if (classifyTransitionType(lensName)) return lensName;
      }
    }

    return getSelectedTransitionTypeFromDom();
  }

  function isLikelyLensColorCardName(name) {
    var label = normalizeLabel(name).split(' - ')[0];
    if (!label || isLikelyThicknessTierName(label) || isLikelyTransitionTypeName(label)) {
      return false;
    }
    return /^(gray|grey|brown|green|graphite|amber|amethyst|ruby|sapphire|emerald|g[\s.-]?15|style\s*colors?)/i.test(
      label
    );
  }

  function isLikelyColorSwatchCard(wrapper) {
    if (!wrapper) return false;

    var btn = wrapper.querySelector('.la-label-btn');
    if (!btn) return false;

    var titleNode = wrapper.querySelector('.la-label-title');
    var cardTitle = titleNode ? normalizeLabel(titleNode.textContent).split(' - ')[0] : '';
    if (!cardTitle || isLikelyThicknessTierName(cardTitle) || isLikelyTransitionTypeName(cardTitle)) {
      return false;
    }
    if (isLikelyLensColorCardName(cardTitle)) return true;

    return !!btn.querySelector(
      '.la-label-image img, .la-label-image-wapper img, .la-label-image-wapper .la-label-image'
    );
  }

  function countColorSwatchCards(scope) {
    var wrappers = scope.querySelectorAll('.la-label-btn-wrapper');
    var swatchCount = 0;
    var i;

    for (i = 0; i < wrappers.length; i++) {
      if (isLikelyColorSwatchCard(wrappers[i])) swatchCount++;
    }

    return swatchCount;
  }

  function isNonTransitionsLensGroupTitle(title) {
    return /^(clear|blue\s*light|sunglass(?:es)?|polarized|non[\s-]?polarized)\b/i.test(
      normalizeLabel(title)
    );
  }

  function isTransitionsGroupTitle(title) {
    var label = normalizeLabel(title);
    if (!label || isNonTransitionsLensGroupTitle(label)) return false;
    return /\btransitions?\b|photochromic|xtr\s*active|xtractive/i.test(label);
  }

  function getLensAdvizorCustomOptionValue(la, keyPattern) {
    if (!la) return '';

    var sources = [la.customOptions || {}, la.customFieldData || {}];
    var i;
    var j;
    var source;
    var keys;
    var key;

    for (i = 0; i < sources.length; i++) {
      source = sources[i];
      keys = Object.keys(source);
      for (j = 0; j < keys.length; j++) {
        key = keys[j];
        if (keyPattern.test(key)) return normalizeLabel(source[key]);
      }
    }

    return '';
  }

  function hasTransitionsThicknessSelected(la) {
    la = la || window.LensAdvizor;
    if (!la) return false;

    var thicknessValue = getLensAdvizorCustomOptionValue(la, /lens\s*thickness|lens\s*material|^material$/i);
    if (thicknessValue && isLikelyThicknessTierName(thicknessValue.split(' - ')[0])) {
      return true;
    }

    var chooseLenses = getLensAdvizorCustomOptionValue(la, /choose\s*your\s*lenses/i);
    if (chooseLenses && isLikelyTransitionTypeName(chooseLenses)) {
      return true;
    }

    return false;
  }

  function isTransitionsLensFlowFromLensAdvizor(la) {
    la = la || window.LensAdvizor;
    if (!la || !la.response) return false;

    if (la.lensGroups && la.response.lensGroupSelected) {
      var selectedKey = la.response.lensGroupSelected;
      var i;
      for (i = 0; i < la.lensGroups.length; i++) {
        var group = la.lensGroups[i];
        if (group.group_type !== selectedKey && String(group.id) !== String(selectedKey)) {
          continue;
        }
        if (isTransitionsGroupTitle(group.group_title || group.title || '')) {
          return true;
        }
      }
    }

    var lens = la.response.lens;
    if (lens) {
      var groupTitle = normalizeLabel(lens.group_title || '');
      var groupType = normalizeLabel(lens.group_type || '');
      if (
        /transition|photochromic|xtr\s*active|xtractive/i.test(groupTitle) ||
        /transition|photochromic|xtr\s*active|xtractive/i.test(groupType)
      ) {
        return true;
      }
    }

    return hasTransitionsThicknessSelected(la);
  }

  function getCheckedTransitionsGroupLabel(root) {
    root = root || document;
    var checked = root.querySelector(
      LENS_GROUP_STEP_SELECTOR + ' input[type="radio"].la-tap-select:checked'
    );
    if (!checked) {
      checked = root.querySelector(
        '.la-render-lenses.x-pro input[type="radio"].la-tap-select:checked'
      );
    }
    if (!checked) return '';

    var btn = checked.closest('.la-label-btn');
    var titleNode = btn && btn.querySelector('.la-label-title');
    return titleNode ? titleNode.textContent : checked.value || '';
  }

  function isTransitionsLensFlowFromDom() {
    var label = getCheckedTransitionsGroupLabel(document);
    if (label && isTransitionsGroupTitle(label)) return true;

    var modal = document.getElementById('lensadvizor-prescription-modal');
    if (!modal) return false;

    label = getCheckedTransitionsGroupLabel(modal);
    return !!(label && isTransitionsGroupTitle(label));
  }

  function isTransitionsLensFlow(la) {
    var colorScope = findColorScope();
    if (colorScope && isExplicitColorStepScope(colorScope)) return true;

    if (isTransitionsLensFlowFromLensAdvizor(la) || isTransitionsLensFlowFromDom()) {
      return true;
    }
    if (hasTransitionsThicknessSelected(la)) return true;
    return !!classifyTransitionType(getSelectedTransitionTypeName(la));
  }

  function getScopeTitle(scope) {
    if (!scope) return '';

    function readTitleEl(titleEl) {
      return titleEl ? normalizeLabel(titleEl.textContent) : '';
    }

    var titleEl =
      scope.querySelector('#la_prescriptionSelect_title') ||
      scope.querySelector('.la-wrapper-heading h3') ||
      scope.querySelector('.la-wrapper-heading h2') ||
      scope.querySelector('.la-wrapper-heading');
    var title = readTitleEl(titleEl);
    if (title) return title;

    var body = scope.closest('.la-prescription-modal-content-body');
    if (!body) return '';

    titleEl =
      body.querySelector('#la_prescriptionSelect_title') ||
      body.querySelector(':scope > .la-wrapper-heading h3') ||
      body.querySelector(':scope > .la-wrapper-heading h2') ||
      body.querySelector(':scope > .la-wrapper-heading');
    return readTitleEl(titleEl);
  }

  function countCardTypes(scope) {
    var wrappers = scope.querySelectorAll('.la-label-btn-wrapper');
    var title = getScopeTitle(scope);
    var forceColorCards = matchesKnownColorStepHeading(title);
    var tierCount = 0;
    var typeCount = 0;
    var colorCount = 0;
    var i;

    for (i = 0; i < wrappers.length; i++) {
      var titleNode = wrappers[i].querySelector('.la-label-title');
      var cardTitle = titleNode ? normalizeLabel(titleNode.textContent) : '';
      if (isLikelyThicknessTierName(cardTitle)) tierCount++;
      else if (!forceColorCards && isLikelyTransitionTypeName(cardTitle)) typeCount++;
      else if (isLikelyLensColorCardName(cardTitle) || isLikelyColorSwatchCard(wrappers[i])) {
        colorCount++;
      }
    }

    return {
      wrappers: wrappers.length,
      tierCount: tierCount,
      typeCount: typeCount,
      colorCount: colorCount
    };
  }

  function isLensPackageScope(scope) {
    if (!scope || !scope.classList.contains('la-render-lenses') || scope.classList.contains('x-pro')) {
      return false;
    }
    if (isTransitionTypeScope(scope)) return false;

    var title = getScopeTitle(scope);
    if (/choose\s+lens\s+package/i.test(title)) return true;

    var counts = countCardTypes(scope);
    return counts.tierCount >= 2 && counts.typeCount < 1;
  }

  function isTransitionTypeScope(scope) {
    if (!scope) return false;
    var title = getScopeTitle(scope);
    if (matchesKnownColorStepHeading(title) || isLensColorOptionTitle(title)) return false;

    var counts = countCardTypes(scope);
    return counts.typeCount >= 1 && counts.tierCount < 2 && counts.colorCount < 2;
  }

  function getSelectedUsageLabel() {
    var la = window.LensAdvizor;
    if (la && la.response && la.response.selectedPrescriptionType) {
      var selected = la.response.selectedPrescriptionType;
      if (selected && selected.title) {
        if (la.Translation && typeof la.Translation.getTranslatedText === 'function') {
          try {
            var translated = la.Translation.getTranslatedText(selected.title);
            if (translated) return normalizeLabel(translated);
          } catch (err) {
            /* fall through */
          }
        }
        if (typeof selected.title === 'string') return normalizeLabel(selected.title);
      }
    }

    var modal = document.getElementById('lensadvizor-prescription-modal');
    if (!modal) return '';

    var usageWrapper = modal.querySelector(
      '.la-choose-prescription-wrapper:not(.la-render-lenses):not(.la-render-options):not(.la-render-review):not(.la-render-addons)'
    );
    if (!usageWrapper) return '';

    var checked = usageWrapper.querySelector('input[type="radio"]:checked');
    if (!checked) return '';

    var btn = checked.closest('.la-label-btn, label.la-label-btn, label');
    var titleEl = btn && btn.querySelector('.la-label-title');
    return titleEl ? normalizeLabel(titleEl.textContent) : '';
  }

  function isNonPrescriptionFlow() {
    var la = window.LensAdvizor;
    if (la && la.response && la.response.selectedPrescriptionType) {
      var selected = la.response.selectedPrescriptionType;
      var text = '';
      if (typeof selected === 'string') {
        text = selected;
      } else if (selected) {
        text = [selected.title, selected.name, selected.type, selected.handle]
          .filter(Boolean)
          .join(' ');
      }
      if (/non[\s-]?prescription|fashion|plano/i.test(text)) return true;
    }
    return /non[\s-]?prescription|fashion|plano/i.test(getSelectedUsageLabel());
  }

  function isProgressivePrescriptionFlow() {
    var la = window.LensAdvizor;
    if (la && la.response && la.response.selectedPrescriptionType) {
      var selected = la.response.selectedPrescriptionType;
      var text = '';
      if (typeof selected === 'string') {
        text = selected;
      } else if (selected) {
        text = [selected.title, selected.name, selected.type, selected.handle]
          .filter(Boolean)
          .join(' ');
      }
      if (/progressive/i.test(text)) return true;
    }
    return /progressive/i.test(getSelectedUsageLabel());
  }

  // The progressive-type options step (e.g. Ultimate HD / Varilux / ZEISS) renders on
  // the same .la-render-options wrapper as color/thickness in a transitions progressive
  // flow. It has no tier, color, or transition-type cards — so the generic color-scope
  // fallback used to misread it as a color step (wrong "Select color" title + narrow width).
  function isProgressiveTypeOptionsScope(scope) {
    if (!scope || !scope.classList.contains('la-render-options')) return false;
    if (!isProgressivePrescriptionFlow()) return false;
    var counts = countCardTypes(scope);
    if (counts.tierCount >= 2) return false;
    if (counts.colorCount >= 1) return false;
    if (counts.typeCount >= 1) return false;
    return counts.wrappers >= 2;
  }

  function isCombinedColorAndThicknessScope(scope) {
    if (!scope || !scope.classList.contains('la-render-options')) return false;
    var counts = countCardTypes(scope);
    return counts.colorCount >= 1 && counts.tierCount >= 2;
  }

  function isNonPrescriptionCombinedScope(scope) {
    return (
      (isTransitionsLensFlowFromLensAdvizor() || isTransitionsLensFlowFromDom()) &&
      isNonPrescriptionFlow() &&
      isCombinedColorAndThicknessScope(scope)
    );
  }

  function findNonPrescriptionCombinedScope() {
    var scopes = document.querySelectorAll(
      '.la-choose-prescription-wrapper.la-render-options'
    );
    var i;
    for (i = 0; i < scopes.length; i++) {
      if (isNonPrescriptionCombinedScope(scopes[i])) return scopes[i];
    }
    return null;
  }

  function isCombinedColorPhaseActive() {
    if (combinedColorConfirmed) return false;
    if (
      !(isTransitionsLensFlowFromLensAdvizor() || isTransitionsLensFlowFromDom()) ||
      !isNonPrescriptionFlow()
    ) {
      return false;
    }
    var scopes = document.querySelectorAll(
      '.la-choose-prescription-wrapper.la-render-options'
    );
    var i;
    for (i = 0; i < scopes.length; i++) {
      if (isCombinedColorAndThicknessScope(scopes[i])) return true;
    }
    return false;
  }

  function isColorCardWrapper(wrapper) {
    if (!wrapper) return false;
    if (isLikelyColorSwatchCard(wrapper)) return true;
    var titleNode = wrapper.querySelector('.la-label-title');
    var cardTitle = titleNode ? normalizeLabel(titleNode.textContent) : '';
    return isLikelyLensColorCardName(cardTitle);
  }

  function isTierCardWrapper(wrapper) {
    if (!wrapper) return false;
    var titleNode = wrapper.querySelector('.la-label-title');
    var cardTitle = titleNode ? normalizeLabel(titleNode.textContent) : '';
    return isLikelyThicknessTierName(cardTitle);
  }

  function setWrapperHidden(wrapper, hiddenClass, hidden) {
    if (!wrapper) return;
    if (hidden) {
      wrapper.classList.add(hiddenClass);
      wrapper.style.setProperty('display', 'none', 'important');
      return;
    }
    wrapper.classList.remove(hiddenClass);
    if (
      !wrapper.classList.contains(TIER_HIDDEN_CLASS) &&
      !wrapper.classList.contains(COLOR_HIDDEN_CLASS)
    ) {
      wrapper.style.removeProperty('display');
    }
  }

  function setOptionListPlain(list, plain) {
    if (!list) return;
    if (plain) {
      list.classList.add(LIST_PLAIN_CLASS);
      list.style.setProperty('border', 'none', 'important');
      list.style.setProperty('box-shadow', 'none', 'important');
      list.style.setProperty('background', 'transparent', 'important');
      return;
    }
    list.classList.remove(LIST_PLAIN_CLASS);
    list.style.removeProperty('border');
    list.style.removeProperty('box-shadow');
    list.style.removeProperty('background');
  }

  function getGroupOptionList(groupContainer) {
    if (!groupContainer) return null;
    return (
      groupContainer.querySelector(':scope > .la-option-list') ||
      groupContainer.querySelector('.la-option-list')
    );
  }

  function clearCombinedVisibility(root) {
    var rootNode = root || document;
    rootNode
      .querySelectorAll(
        '.' + TIER_HIDDEN_CLASS + ', .' + COLOR_HIDDEN_CLASS
      )
      .forEach(function (wrapper) {
        wrapper.classList.remove(TIER_HIDDEN_CLASS, COLOR_HIDDEN_CLASS);
        wrapper.style.removeProperty('display');
      });
    rootNode.querySelectorAll('.' + LIST_PLAIN_CLASS).forEach(function (list) {
      setOptionListPlain(list, false);
    });
  }

  function applyCombinedPhaseVisibility(scope) {
    if (!scope || !isNonPrescriptionCombinedScope(scope)) return;

    var wrappers = scope.querySelectorAll('.la-label-btn-wrapper');
    var i;
    for (i = 0; i < wrappers.length; i++) {
      var wrapper = wrappers[i];
      var isColor = isColorCardWrapper(wrapper);
      var isTier = isTierCardWrapper(wrapper);

      if (!combinedColorConfirmed) {
        setWrapperHidden(wrapper, TIER_HIDDEN_CLASS, isTier);
        setWrapperHidden(wrapper, COLOR_HIDDEN_CLASS, false);
      } else {
        setWrapperHidden(wrapper, COLOR_HIDDEN_CLASS, isColor);
        setWrapperHidden(wrapper, TIER_HIDDEN_CLASS, false);
      }
    }

    // Group titles inside the form (e.g. "Photochromic Color", "Lens Thickness")
    var groupTitles = scope.querySelectorAll('h3.la-lensgroup-title');
    var j;
    for (j = 0; j < groupTitles.length; j++) {
      var titleEl = groupTitles[j];
      // Distance/Reading has no group headings — hide all in both phases
      setWrapperHidden(titleEl, TIER_HIDDEN_CLASS, true);
      setWrapperHidden(titleEl, COLOR_HIDDEN_CLASS, false);
    }

    // Dividers between option groups (light gray line)
    var dividers = scope.querySelectorAll('.la-divider');
    var d;
    for (d = 0; d < dividers.length; d++) {
      if (!combinedColorConfirmed) {
        setWrapperHidden(dividers[d], TIER_HIDDEN_CLASS, true);
        setWrapperHidden(dividers[d], COLOR_HIDDEN_CLASS, false);
      } else {
        setWrapperHidden(dividers[d], COLOR_HIDDEN_CLASS, true);
        setWrapperHidden(dividers[d], TIER_HIDDEN_CLASS, false);
      }
    }

    // Option group containers (title + .la-option-list shell / dark border)
    for (j = 0; j < groupTitles.length; j++) {
      titleEl = groupTitles[j];
      var titleText = normalizeLabel(titleEl.textContent);
      var isThicknessTitle = /lens\s*thickness|lens\s*material|^material$/i.test(titleText);
      var isColorTitle = /\bcolor\b/i.test(titleText) && !isThicknessTitle;
      var groupContainer = titleEl.closest('.la-option-container');
      if (
        !groupContainer ||
        groupContainer.id === 'la-prescription-form' ||
        groupContainer.classList.contains('la-prescription-wrapper')
      ) {
        continue;
      }

      if (!combinedColorConfirmed) {
        setWrapperHidden(groupContainer, TIER_HIDDEN_CLASS, isThicknessTitle);
        setWrapperHidden(groupContainer, COLOR_HIDDEN_CLASS, false);
        setOptionListPlain(getGroupOptionList(groupContainer), !isThicknessTitle);
      } else {
        setWrapperHidden(groupContainer, COLOR_HIDDEN_CLASS, isColorTitle);
        setWrapperHidden(groupContainer, TIER_HIDDEN_CLASS, false);
        setOptionListPlain(getGroupOptionList(groupContainer), !isColorTitle);
      }
    }
  }

  function resetCombinedPhase(root) {
    combinedColorConfirmed = false;
    stopCombinedPhaseBWatch();
    clearCombinedVisibility(root);
    document.body.classList.remove('ciw-la-combined-phase-b');
  }

  /* Transitions drawer already picked color — enter combined phase B (package tiers). */
  function markCombinedColorConfirmedFromDrawer() {
    if (!isNonPrescriptionFlow()) return false;
    if (!(isTransitionsLensFlowFromLensAdvizor() || isTransitionsLensFlowFromDom())) {
      return false;
    }

    var combinedScope = findNonPrescriptionCombinedScope();
    if (!combinedScope) return false;
    if (combinedColorConfirmed) {
      applyCombinedPhaseBSync();
      return true;
    }

    combinedColorConfirmed = true;
    document.body.classList.add('ciw-la-combined-phase-b');
    deactivateStep();
    applyCombinedPhaseVisibility(combinedScope);
    setCombinedPhasePackageTitle(combinedScope);
    startCombinedPhaseBWatch();
    document.dispatchEvent(new CustomEvent('ciw-la-lens-color:combined-phase-b'));
    document.dispatchEvent(new CustomEvent('ciw-la-lens-color:continue-sync'));
    scheduleScan();
    return true;
  }

  function setCombinedPhasePackageTitle(scope) {
    if (!scope) return;

    var titleEl =
      scope.querySelector('#la_prescriptionSelect_title') ||
      scope.querySelector('.la-wrapper-heading h3');

    if (!titleEl) {
      var body = scope.closest('.la-prescription-modal-content-body');
      if (body) {
        titleEl =
          body.querySelector('#la_prescriptionSelect_title') ||
          body.querySelector(':scope > .la-wrapper-heading h3') ||
          body.querySelector('.la-wrapper-heading h3');
      }
    }

    if (!titleEl) return;

    var packageTitle =
      (window.ciwLaStepTitles && window.ciwLaStepTitles.lenses) ||
      'Choose lens package';
    if (titleEl.textContent.trim() === packageTitle) return;
    titleEl.textContent = packageTitle;
  }

  function scopeHasTransitionColorCards(scope) {
    if (!scope) return false;

    var counts = countCardTypes(scope);
    if (counts.tierCount >= 2) return false;
    if (counts.colorCount >= 1 && counts.tierCount < 2 && counts.typeCount < 1) return true;

    return countColorSwatchCards(scope) >= 1;
  }

  function isThicknessOptionScope(scope) {
    if (!scope) return false;
    if (isLensPackageScope(scope)) return true;
    if (!scope.classList.contains('la-render-options')) return false;

    var title = getScopeTitle(scope);
    if (/lens\s*thickness|lens\s*material|^material$/i.test(title)) return true;
    if (isLensColorOptionTitle(title)) return false;

    var counts = countCardTypes(scope);
    if (counts.tierCount >= 2) return true;

    if (scopeHasTransitionColorCards(scope)) return false;
    return false;
  }

  function isTransitionColorOptionsStep(scope) {
    if (!scope) return false;
    if (isLensPackageScope(scope)) return false;
    if (isThicknessOptionScope(scope)) return false;

    var isOptionsStep =
      scope.classList.contains('la-render-options') ||
      (scope.classList.contains('la-render-lenses') && !scope.classList.contains('x-pro'));
    if (!isOptionsStep) return false;

    if (scopeHasTransitionColorCards(scope) && isTransitionsLensFlow()) return true;

    var transitionTypeKey = classifyTransitionType(getSelectedTransitionTypeName());
    if (!transitionTypeKey) return false;

    var counts = countCardTypes(scope);
    if (counts.tierCount >= 2 || counts.typeCount >= 1) return false;

    var swatchCount = countColorSwatchCards(scope);
    return counts.colorCount >= 1 || swatchCount >= 2;
  }

  function isTransitionsLensFlowForColorScope(la) {
    la = la || window.LensAdvizor;
    if (isTransitionsLensFlowFromLensAdvizor(la) || isTransitionsLensFlowFromDom()) {
      return true;
    }
    if (hasTransitionsThicknessSelected(la)) return true;
    return !!classifyTransitionType(getSelectedTransitionTypeName(la));
  }

  function isColorOptionScope(scope) {
    if (!scope) return false;
    if (isNonPrescriptionCombinedScope(scope)) {
      return !combinedColorConfirmed;
    }
    if (!isTransitionsLensFlowForColorScope()) return false;
    if (isLensPackageScope(scope)) return false;
    if (isProgressiveTypeOptionsScope(scope)) return false;

    var title = getScopeTitle(scope);
    if (matchesKnownColorStepHeading(title) || isLensColorOptionTitle(title)) return true;

    if (isThicknessOptionScope(scope)) return false;
    if (isTransitionColorOptionsStep(scope)) return true;

    if (isTransitionTypeScope(scope)) return false;

    var counts = countCardTypes(scope);
    if (counts.colorCount >= 1) return true;
    if (counts.wrappers >= 2 && counts.tierCount < 2 && counts.typeCount < 1) return true;

    return false;
  }

  function isVisibleInModal(el) {
    if (!el || el.hasAttribute('hidden')) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    return el.getClientRects().length > 0;
  }

  function findColorScope() {
    var modal = document.getElementById('lensadvizor-prescription-modal');
    var roots = modal ? [modal, document] : [document];
    var r;
    var i;
    var j;
    var scope;
    var scopes;

    for (r = 0; r < roots.length; r++) {
      for (i = 0; i < STEP_SELECTORS.length; i++) {
        scopes = roots[r].querySelectorAll(STEP_SELECTORS[i]);
        for (j = 0; j < scopes.length; j++) {
          scope = scopes[j];
          if (!isVisibleInModal(scope)) continue;
          if (isColorOptionScope(scope)) return scope;
        }
      }
    }

    for (i = 0; i < STEP_SELECTORS.length; i++) {
      scope = document.querySelector(STEP_SELECTORS[i]);
      if (scope && isColorOptionScope(scope)) return scope;
    }

    return null;
  }

  function getScope() {
    var scope = findColorScope();
    if (!scope) return null;
    if (isExplicitColorStepScope(scope)) return scope;
    if (!isTransitionsLensFlow()) return null;
    return scope;
  }

  function isActive() {
    return !!(window.ciwLaHostApi && window.ciwLaHostApi.isEyeglass()) && !!getScope();
  }

  function getWrappers(scope) {
    scope = scope || getScope();
    if (!scope) return [];
    var wrappers = Array.prototype.slice.call(
      scope.querySelectorAll('.la-label-btn-wrapper')
    );
    if (isNonPrescriptionCombinedScope(scope) && !combinedColorConfirmed) {
      return wrappers.filter(isColorCardWrapper);
    }
    return wrappers;
  }

  function getCardBtn(wrapper) {
    return wrapper ? wrapper.querySelector('.la-label-btn') : null;
  }

  function getRadio(wrapper) {
    if (!wrapper) return null;
    return (
      wrapper.querySelector('input[type="radio"].la-tap-select') ||
      wrapper.querySelector('input[type="radio"]') ||
      wrapper.querySelector('input.la-tap-select')
    );
  }

  function canContinue() {
    return (
      document.body.classList.contains(BODY_ACTIVE_CLASS) &&
      !!pendingWrapper &&
      !confirming
    );
  }

  function getSubmitForm(scope) {
    if (scope) {
      var scopeForm =
        (scope.closest && scope.closest('#la-prescription-form')) ||
        scope.querySelector('#la-prescription-form');
      if (scopeForm) return scopeForm;
    }
    return (
      document.querySelector('#la-prescription-form[data-form="options"]') ||
      document.querySelector('#la-prescription-form[data-form="lenses"]') ||
      document.querySelector('#la-prescription-form')
    );
  }

  function syncCheckedRadios(scope, selectedWrapper) {
    getWrappers(scope).forEach(function (wrapper) {
      var input = getRadio(wrapper);
      if (input) input.checked = wrapper === selectedWrapper;
    });
  }

  function getColorSubmitForm() {
    return document.querySelector('#la-prescription-form[data-form="options"]');
  }

  function escapeAttrValue(value) {
    return String(value || '')
      .replace(/\\/g, '\\\\')
      .replace(/"/g, '\\"');
  }

  function resolveSubmitRadio(scope, wrapper) {
    var radio = getRadio(wrapper);
    if (!radio) return null;

    var optionsForm = getColorSubmitForm();
    if (!optionsForm) return radio;

    if (scope && scope.classList.contains('la-render-options') && optionsForm.contains(radio)) {
      return radio;
    }

    var name = radio.name;
    var value = radio.value;
    if (name && value) {
      var match = optionsForm.querySelector(
        'input[type="radio"][name="' + escapeAttrValue(name) + '"][value="' + escapeAttrValue(value) + '"]'
      );
      if (match) return match;
    }

    if (optionsForm.contains(radio)) return radio;
    return radio;
  }

  function submitColorChoice(radio, la) {
    if (!radio || !la) return;

    // Color is an intermediate LA option step (renderOption). Native LA uses
    // handleSingleOptionChange to bump optionLevel and render the next option.
    // handleFormSubmit on the options form skips ahead to review/add-ons.
    if (typeof la.handleSingleOptionChange === 'function') {
      la.handleSingleOptionChange({ target: radio });
      return;
    }

    if (typeof la.handleOptionChange === 'function') {
      la.handleOptionChange({ target: radio, type: 'click' });
    }

    var submitForm = getColorSubmitForm();
    if (submitForm && typeof la.handleFormSubmit === 'function') {
      la.handleFormSubmit({
        target: submitForm,
        preventDefault: function () {},
        stopImmediatePropagation: function () {}
      });
      return;
    }

    if (submitForm) {
      submitForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  }

  function findRecommendedWrapper(scope) {
    var wrappers = getWrappers(scope);
    for (var i = 0; i < wrappers.length; i++) {
      if (
        wrappers[i].classList.contains('recommendation-label-container') ||
        wrappers[i].classList.contains('boxy-recommendation-label-container')
      ) {
        return wrappers[i];
      }
    }
    return null;
  }

  function clearCheckedRadios(scope) {
    getWrappers(scope).forEach(function (wrapper) {
      var radio = getRadio(wrapper);
      if (radio) radio.checked = false;
    });
  }

  function setPicked(wrapper, scopeHint) {
    var scope = scopeHint || boundScope || getScope();
    if (!scope) return;

    getWrappers(scope).forEach(function (item) {
      var btn = getCardBtn(item);
      if (!btn) return;
      btn.classList.toggle(PICKED_CLASS, item === wrapper);
    });

    pendingWrapper = wrapper || null;
    document.dispatchEvent(new CustomEvent('ciw-la-lens-color:selection-changed'));
  }

  function defaultPick(scope) {
    var rec = findRecommendedWrapper(scope);
    if (rec) {
      setPicked(rec, scope);
      return;
    }
    var wrappers = getWrappers(scope);
    if (wrappers.length) setPicked(wrappers[0], scope);
  }

  function isInteractiveTarget(target) {
    return !!(
      target &&
      target.closest &&
      target.closest('[data-la-tooltip], .tooltip-span, .la-tooltip, .la-help-icon')
    );
  }

  function getWrapperFromEventTarget(target) {
    if (!target || !target.closest) return null;
    var btn = target.closest('.la-label-btn');
    if (!btn) return null;
    return btn.closest('.la-label-btn-wrapper');
  }

  function onStepPointerDown(event) {
    if (!isActive() || confirming) return;
    if (isInteractiveTarget(event.target)) return;

    var scope = getScope();
    var wrapper = getWrapperFromEventTarget(event.target);
    if (!wrapper || !scope.contains(wrapper)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    setPicked(wrapper);
  }

  /* GlassesUSA-style: clicking a color card confirms immediately (auto-advance)
     on every viewport. Only runs from a real click (not pointerdown or defaultPick). */
  function maybeAutoAdvanceOnClick() {
    if (confirming || !pendingWrapper) return;
    confirmSelection();
  }

  function onStepClickCapture(event) {
    if (!isActive() || confirming) return;

    var scope = getScope();
    var radio = event.target.closest && event.target.closest('input.la-tap-select');
    if (radio && scope && scope.contains(radio)) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      setPicked(radio.closest('.la-label-btn-wrapper'));
      maybeAutoAdvanceOnClick();
      return;
    }

    if (isInteractiveTarget(event.target)) return;

    var wrapper = getWrapperFromEventTarget(event.target);
    if (!wrapper || !scope.contains(wrapper)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    setPicked(wrapper);
    maybeAutoAdvanceOnClick();
  }

  async function confirmSelection() {
    if (!isActive() || confirming || !pendingWrapper) return;

    var scope = boundScope || getScope();
    var wrapper = pendingWrapper;
    var la = window.LensAdvizor;
    if (!scope || !wrapper || !la) return;

    if (isNonPrescriptionCombinedScope(scope) && !combinedColorConfirmed) {
      confirming = true;
      syncCheckedRadios(scope, wrapper);

      try {
        var combinedRadio = resolveSubmitRadio(scope, wrapper);
        if (combinedRadio) {
          submitColorChoice(combinedRadio, la);
        } else {
          var combinedBtn = getCardBtn(wrapper);
          if (combinedBtn) combinedBtn.click();
        }

        combinedColorConfirmed = true;
        document.body.classList.add('ciw-la-combined-phase-b');
        applyCombinedPhaseVisibility(scope);
        setCombinedPhasePackageTitle(scope);
        deactivateStep();
        document.dispatchEvent(new CustomEvent('ciw-la-lens-color:combined-phase-b'));
        document.dispatchEvent(new CustomEvent('ciw-la-lens-color:continue-sync'));
      } finally {
        confirming = false;
        pendingWrapper = null;
      }
      startCombinedPhaseBWatch();
      scheduleScan();
      return;
    }

    var radio = resolveSubmitRadio(scope, wrapper);
    if (!radio) {
      var clickBtn = getCardBtn(wrapper);
      if (!clickBtn) return;

      confirming = true;
      deactivateStep();
      try {
        clickBtn.click();
      } finally {
        confirming = false;
        pendingWrapper = null;
      }
      return;
    }

    confirming = true;
    syncCheckedRadios(scope, wrapper);
    deactivateStep();

    try {
      submitColorChoice(radio, la);
    } finally {
      confirming = false;
      pendingWrapper = null;
    }
  }

  window.ciwLaLensColorContinue.confirm = confirmSelection;

  function onContinueClick(event) {
    if (!isActive() || confirming || !pendingWrapper) return;
    var btn = event.target.closest('.la-prescription-form-btn');
    if (!btn || !btn.closest('.la-prescription-modal-footer')) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    confirmSelection();
  }

  function bindScope(scope) {
    if (!scope || boundScope === scope) return;
    unbindScope();
    boundScope = scope;
    scope.classList.add(SCOPE_CLASS);
    scope.addEventListener('pointerdown', onStepPointerDown, true);
    scope.addEventListener('click', onStepClickCapture, true);
  }

  function unbindScope() {
    if (!boundScope) return;
    boundScope.classList.remove(SCOPE_CLASS);
    boundScope.removeEventListener('pointerdown', onStepPointerDown, true);
    boundScope.removeEventListener('click', onStepClickCapture, true);
    boundScope = null;
  }

  function activateStep(scope) {
    scope = scope || getScope();
    if (!scope) return;

    if (isNonPrescriptionCombinedScope(scope)) {
      applyCombinedPhaseVisibility(scope);
    }

    var wasActive = document.body.classList.contains(BODY_ACTIVE_CLASS);
    document.body.classList.add(BODY_ACTIVE_CLASS);
    bindScope(scope);
    clearCheckedRadios(scope);

    if (!wasActive || !pendingWrapper || !scope.contains(pendingWrapper)) {
      defaultPick(scope);
    } else {
      setPicked(pendingWrapper);
    }

    window.setTimeout(function () {
      document.dispatchEvent(new CustomEvent('ciw-la-lens-color:selection-changed'));
    }, 0);
  }

  function deactivateStep() {
    document.body.classList.remove(BODY_ACTIVE_CLASS);
    unbindScope();

    document.querySelectorAll('.' + SCOPE_CLASS).forEach(function (el) {
      var btn = el.querySelector('.la-label-btn.ciw-la-lens-card--picked');
      if (btn) btn.classList.remove(PICKED_CLASS);
    });
  }

  function scan() {
    if (confirming || scanRunning) return;
    scanRunning = true;
    try {
      if (!window.ciwLaHostApi || !window.ciwLaHostApi.isEyeglass()) {
        resetCombinedPhase();
        deactivateStep();
        return;
      }

      if (!isTransitionsLensFlow()) {
        resetCombinedPhase();
      }

      var scope = getScope();
      if (!scope) {
        deactivateStep();
        document.querySelectorAll('.' + SCOPE_CLASS).forEach(function (el) {
          el.classList.remove(SCOPE_CLASS);
        });
        if (combinedColorConfirmed) {
          var combinedScope = findNonPrescriptionCombinedScope();
          if (combinedScope) {
            applyCombinedPhaseVisibility(combinedScope);
            setCombinedPhasePackageTitle(combinedScope);
          }
        }
        return;
      }

      activateStep(scope);
    } finally {
      scanRunning = false;
    }
  }

  function applyCombinedPhaseBSync() {
    if (!combinedColorConfirmed) return;
    var combinedScope = findNonPrescriptionCombinedScope();
    if (!combinedScope) return;
    applyCombinedPhaseVisibility(combinedScope);
    setCombinedPhasePackageTitle(combinedScope);
  }

  /* After confirming the color, LensAdvizor re-renders the combined scope on its own
     schedule (up to ~2.5s later), which wipes our phase-B visibility classes and shows
     the raw color + thickness sections. Rather than blindly waiting for that (the old
     3s freeze that caused the flash), re-apply phase-B visibility on a tight interval so
     the color section stays hidden and the title stays "Choose lens package" the whole
     time. Stops once things settle or the phase resets. */
  function stopCombinedPhaseBWatch() {
    if (!combinedPhaseBWatch) return;
    window.clearInterval(combinedPhaseBWatch);
    combinedPhaseBWatch = null;
  }

  function startCombinedPhaseBWatch() {
    stopCombinedPhaseBWatch();
    var start = Date.now();
    combinedPhaseBWatch = window.setInterval(function () {
      if (!combinedColorConfirmed || Date.now() - start > 4000) {
        stopCombinedPhaseBWatch();
        return;
      }
      applyCombinedPhaseBSync();
    }, 80);
  }

  var scanRunning = false;
  var scanBurstQueued = false;
  var combinedSyncQueued = false;

  function onCombinedOptionsDomChanged() {
    if (combinedSyncQueued) return;
    combinedSyncQueued = true;
    window.requestAnimationFrame(function () {
      combinedSyncQueued = false;
      applyCombinedPhaseBSync();
      scheduleScan();
    });
  }

  function runScanBurst() {
    scan();
    window.setTimeout(scan, 0);
    window.setTimeout(scan, 150);
    window.setTimeout(scan, 400);
    window.setTimeout(scan, 850);
    window.setTimeout(scan, 1600);
  }

  function scheduleScan() {
    if (scanBurstQueued) return;
    scanBurstQueued = true;
    window.requestAnimationFrame(function () {
      scanBurstQueued = false;
      runScanBurst();
    });
  }

  document.addEventListener('click', onContinueClick, true);

  document.addEventListener(
    'click',
    function (event) {
      var back =
        event.target.closest &&
        event.target.closest('.ciw-la-gusa-back-btn, .la-steeper-back');
      if (!back) return;
      if (!combinedColorConfirmed) return;
      var combinedScope = findNonPrescriptionCombinedScope();
      if (!combinedScope || !isVisibleInModal(combinedScope)) return;
      resetCombinedPhase();
      scheduleScan();
    },
    true
  );

  document.addEventListener('ciw-la-lens-color:selection-changed', function () {
    window.setTimeout(function () {
      document.dispatchEvent(new CustomEvent('ciw-la-lens-color:continue-sync'));
    }, 0);
  });

  var EVENTS = [
    'LensAdvizor:lensOptions:rendered',
    'LensAdvizor:lens:rendered',
    'LensAdvizor:selectLensModal:open',
    'LensAdvizor:prescriptionTypes:rendered'
  ];

  EVENTS.forEach(function (eventName) {
    if (eventName === 'LensAdvizor:lensOptions:rendered') {
      document.addEventListener(eventName, onCombinedOptionsDomChanged);
    } else {
      document.addEventListener(eventName, scheduleScan);
    }
  });

  document.addEventListener('DOMContentLoaded', scheduleScan);

  document.addEventListener('ciw-la-transitions-drawer:confirmed', function () {
    window.setTimeout(function () {
      markCombinedColorConfirmedFromDrawer();
    }, 0);
    [80, 200, 450, 900].forEach(function (delay) {
      window.setTimeout(markCombinedColorConfirmedFromDrawer, delay);
    });
  });

  document.addEventListener('LensAdvizor:selectLensModal:close', function () {
    resetCombinedPhase();
    deactivateStep();
  });

  var modal = document.getElementById('lensadvizor-prescription-modal');
  if (modal) {
    new MutationObserver(onCombinedOptionsDomChanged).observe(modal, {
      childList: true,
      subtree: true
    });
  }
})();
